
// import React, { useEffect, useState, useMemo } from "react";
// import axiosAuth from "../api/axiosAuth";
// import { API } from "../components/config";
// import { useAuth } from "../context/AuthContext";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import "../style/Asistencia.css";

// export default function AsistenciaProfesor() {

//   const { user } = useAuth();
//   const profesorId = user?.id;

//   const api = useMemo(() => axiosAuth, []);

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [selectedAsignacion, setSelectedAsignacion] = useState(null);

//   const [students, setStudents] = useState([]);
//   const [asistenciasMap, setAsistenciasMap] = useState({});
//   const [diasSemana, setDiasSemana] = useState([]);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const [fechaNueva, setFechaNueva] = useState("");

//   const estadoColor = {
//     presente: "#c8e6c9",
//     ausente: "#ffcdd2",
//     tarde: "#fff9c4",
//     excusa: "#bbdefb"
//   };

//   /* =========================
//      FORMATEAR FECHA
//   ========================= */
//   const formatDate = (date) => {
//     const d = new Date(date);

//     return [
//       d.getFullYear(),
//       String(d.getMonth() + 1).padStart(2, "0"),
//       String(d.getDate()).padStart(2, "0")
//     ].join("-");
//   };

//   /* =========================
//      ASIGNACIONES
//   ========================= */
// /* =========================
//    ASIGNACIONES
// ========================= */
// useEffect(() => {
//   if (!user) return;

//   const cargarAsignaciones = async () => {
//     try {
//       const res = await api.get(
//         `${API}/asistencias/asignaciones`
//       );

//       console.log("📚 ASIGNACIONES:", res.data);

//       // Soporta ambos formatos:
//       // 1. { ok:true, asignaciones:[...] }
//       // 2. [ ... ]
//       const lista = Array.isArray(res.data?.asignaciones)
//         ? res.data.asignaciones
//         : Array.isArray(res.data)
//         ? res.data
//         : [];

//       setAsignaciones(lista);

//     } catch (err) {
//       console.error(
//         "❌ Error cargando asignaciones:",
//         err
//       );

//       setAsignaciones([]);
//     }
//   };

//   cargarAsignaciones();

// }, [user, api]);

// /* =========================
//    SELECCIONAR ASIGNACIÓN
// ========================= */
// const handleSelectAsignacion = (e) => {

//   const id = Number(e.target.value);

//   const found = (Array.isArray(asignaciones)
//     ? asignaciones
//     : []
//   ).find(
//     (a) => Number(a.asignacion_id) === id
//   );

//   setSelectedAsignacion(found || null);

// };

//   /* =========================
//      CARGAR ESTUDIANTES
//   ========================= */
//   useEffect(() => {
//     if (!selectedAsignacion) return;

//     setLoading(true);
//     setError("");

//     const fetchData = async () => {
//       try {

//         /* ESTUDIANTES */
//         const resEst = await api.get(
//           `${API}/asistencias/estudiantes`,
//           {
//             params: {
//               grado: selectedAsignacion.grado,
//               grupo: selectedAsignacion.grupo
//             }
//           }
//         );

//         // const estudiantes = resEst.data?.estudiantes || resEst.data || [];

//         const estudiantes = Array.isArray(resEst.data?.estudiantes)
//   ? resEst.data.estudiantes
//   : Array.isArray(resEst.data)
//     ? resEst.data
//     : [];

//         setStudents(estudiantes);

//         /* DÍAS */
//         const resDias = await api.get(
//           `${API}/asistencias/dias/${selectedAsignacion.asignacion_id}`
//         );

//      const dias = Array.isArray(resDias.data?.dias)
//   ? resDias.data.dias
//   : Array.isArray(resDias.data)
//     ? resDias.data
//     : [formatDate(new Date())];

//         setDiasSemana(dias);

//         /* MAPA BASE */
//         const nuevoMapa = {};

//         estudiantes.forEach((s) => {
//           nuevoMapa[s.estudiante_id] = {};

//           dias.forEach((d) => {
//             nuevoMapa[s.estudiante_id][d] = "presente";
//           });
//         });

//         /* ASISTENCIAS REALES */
//         const promesas = dias.map((dia) =>
//           api.get(
//             `${API}/asistencias/asignacion/${selectedAsignacion.asignacion_id}/fecha/${dia}`
//           )
//         );

//         const respuestas = await Promise.all(promesas);

//      respuestas.forEach((res, index) => {
//   const dia = dias[index];

//   const asistencias = Array.isArray(res.data?.asistencias)
//     ? res.data.asistencias
//     : Array.isArray(res.data)
//       ? res.data
//       : [];

//   asistencias.forEach((a) => {
//     if (nuevoMapa[a.estudiante_id]) {
//       nuevoMapa[a.estudiante_id][dia] = a.asistencia;
//     }
//   });
// });

//         setAsistenciasMap(nuevoMapa);

//       } catch (err) {
//         console.error(err);
//         setError("Error cargando datos de asistencia");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [selectedAsignacion, api]);

//   /* =========================
//      CAMBIAR ESTADO
//   ========================= */
//   const cambiarEstado = (id, dia, valor) => {
//     setAsistenciasMap((prev) => ({
//       ...prev,
//       [id]: {
//         ...prev[id],
//         [dia]: valor
//       }
//     }));
//   };

//   /* =========================
//      AGREGAR DÍA
//   ========================= */
//   const agregarDia = async () => {
//     try {
//       if (!selectedAsignacion) return alert("Seleccione una asignación");
//       if (!fechaNueva) return alert("Seleccione una fecha");

//       const nuevoDia = formatDate(fechaNueva);

//       if (diasSemana.includes(nuevoDia)) {
//         return alert("Ese día ya existe");
//       }

//       await api.post(`${API}/asistencias/agregar-dia`, {
//         asignacionId: selectedAsignacion.asignacion_id,
//         fecha: nuevoDia
//       });

//       setDiasSemana((prev) => [...prev, nuevoDia]);

//       setAsistenciasMap((prev) => {
//         const nuevoMapa = { ...prev };

//         students.forEach((s) => {
//           if (!nuevoMapa[s.estudiante_id]) {
//             nuevoMapa[s.estudiante_id] = {};
//           }

//           nuevoMapa[s.estudiante_id][nuevoDia] = "presente";
//         });

//         return nuevoMapa;
//       });

//       setFechaNueva("");

//     } catch (err) {
//       console.error(err);
//       alert(err?.response?.data?.message || "Error agregando día");
//     }
//   };

//   /* =========================
//      ELIMINAR DÍA
//   ========================= */
//   const eliminarDia = async (diaEliminar) => {
//     try {
//       if (!selectedAsignacion) return;

//       await api.delete(`${API}/asistencias/eliminar-dia`, {
//         data: {
//           asignacionId: selectedAsignacion.asignacion_id,
//           fecha: diaEliminar
//         }
//       });

//       setDiasSemana((prev) =>
//         prev.filter((d) => d !== diaEliminar)
//       );

//       setAsistenciasMap((prev) => {
//         const nuevo = { ...prev };

//         Object.keys(nuevo).forEach((id) => {
//           delete nuevo[id][diaEliminar];
//         });

//         return nuevo;
//       });

//     } catch (err) {
//       console.error(err);
//       alert("Error eliminando día");
//     }
//   };

//   /* =========================
//      GUARDAR
//   ========================= */
//   const guardar = async () => {
//     try {
//       if (!selectedAsignacion) return alert("Seleccione una asignación");

//       const payload = [];

//       Object.keys(asistenciasMap).forEach((est) => {
//         diasSemana.forEach((dia) => {
//           payload.push({
//             estudiante_id: est,
//             asignacionId: selectedAsignacion.asignacion_id,
//             profesorId,
//             fecha: dia,
//             estado: asistenciasMap[est][dia]
//           });
//         });
//       });

//       await api.post(`${API}/asistencias`, {
//         asistencias: payload,
//         asignacionId: selectedAsignacion.asignacion_id
//       });

//       alert("✅ Asistencias guardadas");

//     } catch (err) {
//       console.error(err);
//       alert("Error guardando");
//     }
//   };

//   /* =========================
//      UI
//   ========================= */
//   return (
//     <div className="ap-container">

//       <div className="ap-header">
//         <h2>Registro de Asistencia</h2>

//         <div className="acciones-superior">

//           <select
//   className="select-asignacion"
//   onChange={handleSelectAsignacion}
//   value={selectedAsignacion?.asignacion_id || ""}
// >
//   <option value="">
//     Seleccione una asignación
//   </option>

//   {(Array.isArray(asignaciones)
//     ? asignaciones
//     : []
//   ).map((a) => (
//     <option
//       key={a.asignacion_id}
//       value={a.asignacion_id}
//     >
//       {a.grado}°{a.grupo} - {a.materia}
//     </option>
//   ))}
// </select>

//           {selectedAsignacion && (
//             <div className="acciones-fecha">

//               <input
//                 type="date"
//                 value={fechaNueva}
//                 onChange={(e) => setFechaNueva(e.target.value)}
//               />

//               <button onClick={agregarDia}>
//                 + Agregar Día
//               </button>

//             </div>
//           )}

//         </div>
//       </div>

//       {error && <div className="error-box">{error}</div>}

//       {loading ? (
//         <div>Cargando...</div>
//       ) : (
//         <div className="ap-table-wrapper">

//           <table className="ap-table">
//             <thead>
//               <tr>
//                 <th>Foto</th>
//                 <th>Estudiante</th>

//                 {diasSemana.map((d) => (
//                   <th key={d}>{d}</th>
//                 ))}

//               </tr>
//             </thead>

//             <tbody>

//               {students.map((s) => (
//                 <tr key={s.estudiante_id}>

//                   <td>
//                     <img
//                       src={s.foto_estudiante ||
//                         "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
//                       alt=""
//                       className="foto-estudiante"
//                     />
//                   </td>

//                 <td>{s.nombre_completo || `${s.nombres_estudiante} ${s.apellidos_estudiante}`}</td>

//                   {diasSemana.map((d) => (
//                     <td
//                       key={d}
//                       style={{
//                         background:
//                           estadoColor[
//                             asistenciasMap[s.estudiante_id]?.[d]
//                           ]
//                       }}
//                     >
//                       <select
//                         value={
//                           asistenciasMap[s.estudiante_id]?.[d] ||
//                           "presente"
//                         }
//                         onChange={(e) =>
//                           cambiarEstado(
//                             s.estudiante_id,
//                             d,
//                             e.target.value
//                           )
//                         }
//                       >
//                         <option value="presente">P</option>
//                         <option value="ausente">A</option>
//                         <option value="tarde">T</option>
//                         <option value="excusa">E</option>
//                       </select>
//                     </td>
//                   ))}

//                 </tr>
//               ))}

//             </tbody>
//           </table>

//         </div>
//       )}

//       <div className="footer-botones">

//         <button onClick={guardar}>💾 Guardar</button>

//       </div>

//     </div>
//   );
// }

//

import React, { useEffect, useState, useMemo } from "react";
import axiosAuth from "../api/axiosAuth";
import { API } from "../components/config";
import { useAuth } from "../context/AuthContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../style/Asistencia.css";

export default function AsistenciaProfesor() {

  const { user } = useAuth();
  const profesorId = user?.id;

  const api = useMemo(() => axiosAuth, []);

  const [asignaciones, setAsignaciones] = useState([]);
  const [selectedAsignacion, setSelectedAsignacion] = useState(null);

  const [students, setStudents] = useState([]);
  const [asistenciasMap, setAsistenciasMap] = useState({});
  const [diasSemana, setDiasSemana] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [fechaNueva, setFechaNueva] = useState("");

  const estadoColor = {
    presente: "#c8e6c9",
    ausente: "#ffcdd2",
    tarde: "#fff9c4",
    excusa: "#bbdefb"
  };

  /* =========================
     FORMATEAR FECHA
  ========================= */
  const formatDate = (date) => {
    const d = new Date(date);

    return [
      d.getFullYear(),
      String(d.getMonth() + 1).padStart(2, "0"),
      String(d.getDate()).padStart(2, "0")
    ].join("-");
  };

  /* =========================
     ASIGNACIONES
  ========================= */
  useEffect(() => {
    if (!user) return;

    const cargarAsignaciones = async () => {
      try {
        const res = await api.get(
          `${API}/asistencias/asignaciones`
        );

        console.log("📚 ASIGNACIONES:", res.data);

        const lista = Array.isArray(res.data?.asignaciones)
          ? res.data.asignaciones
          : Array.isArray(res.data)
          ? res.data
          : [];

        setAsignaciones(lista);

      } catch (err) {
        console.error(
          "❌ Error cargando asignaciones:",
          err
        );

        setAsignaciones([]);
      }
    };

    cargarAsignaciones();

  }, [user, api]);

  /* =========================
     SELECCIONAR ASIGNACIÓN
  ========================= */
  const handleSelectAsignacion = (e) => {

    const id = Number(e.target.value);

    const found = (Array.isArray(asignaciones)
      ? asignaciones
      : []
    ).find(
      (a) => Number(a.asignacion_id) === id
    );

    setSelectedAsignacion(found || null);

  };

  /* =========================
     CARGAR ESTUDIANTES
  ========================= */
  useEffect(() => {
    if (!selectedAsignacion) return;

    setLoading(true);
    setError("");

    const fetchData = async () => {
      try {

        /* ESTUDIANTES */
        const resEst = await api.get(
          `${API}/asistencias/estudiantes`,
          {
            params: {
              grado: selectedAsignacion.grado,
              grupo: selectedAsignacion.grupo
            }
          }
        );

        const estudiantes = Array.isArray(resEst.data?.estudiantes)
          ? resEst.data.estudiantes
          : Array.isArray(resEst.data)
            ? resEst.data
            : [];

        setStudents(estudiantes);

        /* DÍAS */
        const resDias = await api.get(
          `${API}/asistencias/dias/${selectedAsignacion.asignacion_id}`
        );

        console.log("📅 RESPUESTA DÍAS:", resDias.data);

        // 🔧 CORREGIDO: el backend devuelve "fechas", no "dias"
        const dias = Array.isArray(resDias.data?.fechas)
          ? resDias.data.fechas
          : Array.isArray(resDias.data)
            ? resDias.data
            : [formatDate(new Date())];

        setDiasSemana(dias);

        /* MAPA BASE */
        const nuevoMapa = {};

        estudiantes.forEach((s) => {
          nuevoMapa[s.estudiante_id] = {};

          dias.forEach((d) => {
            nuevoMapa[s.estudiante_id][d] = "presente";
          });
        });

        /* ASISTENCIAS REALES */
        const promesas = dias.map((dia) =>
          api.get(
            `${API}/asistencias/asignacion/${selectedAsignacion.asignacion_id}/fecha/${dia}`
          )
        );

        const respuestas = await Promise.all(promesas);

        respuestas.forEach((res, index) => {
          const dia = dias[index];

          const asistencias = Array.isArray(res.data?.asistencias)
            ? res.data.asistencias
            : Array.isArray(res.data)
              ? res.data
              : [];

          asistencias.forEach((a) => {
            if (nuevoMapa[a.estudiante_id]) {
              nuevoMapa[a.estudiante_id][dia] = a.asistencia;
            }
          });
        });

        setAsistenciasMap(nuevoMapa);

      } catch (err) {
        console.error(err);
        setError("Error cargando datos de asistencia");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedAsignacion, api]);

  /* =========================
     CAMBIAR ESTADO
  ========================= */
  const cambiarEstado = (id, dia, valor) => {
    setAsistenciasMap((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [dia]: valor
      }
    }));
  };

  /* =========================
     AGREGAR DÍA
  ========================= */
  const agregarDia = async () => {
    try {
      if (!selectedAsignacion) return alert("Seleccione una asignación");
      if (!fechaNueva) return alert("Seleccione una fecha");

      const nuevoDia = formatDate(fechaNueva);

      if (diasSemana.includes(nuevoDia)) {
        return alert("Ese día ya existe");
      }

      await api.post(`${API}/asistencias/agregar-dia`, {
        asignacionId: selectedAsignacion.asignacion_id,
        fecha: nuevoDia
      });

      setDiasSemana((prev) => [...prev, nuevoDia]);

      setAsistenciasMap((prev) => {
        const nuevoMapa = { ...prev };

        students.forEach((s) => {
          if (!nuevoMapa[s.estudiante_id]) {
            nuevoMapa[s.estudiante_id] = {};
          }

          nuevoMapa[s.estudiante_id][nuevoDia] = "presente";
        });

        return nuevoMapa;
      });

      setFechaNueva("");

    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Error agregando día");
    }
  };

  /* =========================
     ELIMINAR DÍA
  ========================= */
  const eliminarDia = async (diaEliminar) => {
    try {
      if (!selectedAsignacion) return;

      await api.delete(`${API}/asistencias/eliminar-dia`, {
        data: {
          asignacionId: selectedAsignacion.asignacion_id,
          fecha: diaEliminar
        }
      });

      setDiasSemana((prev) =>
        prev.filter((d) => d !== diaEliminar)
      );

      setAsistenciasMap((prev) => {
        const nuevo = { ...prev };

        Object.keys(nuevo).forEach((id) => {
          delete nuevo[id][diaEliminar];
        });

        return nuevo;
      });

    } catch (err) {
      console.error(err);
      alert("Error eliminando día");
    }
  };

  /* =========================
     GUARDAR
  ========================= */
  const guardar = async () => {
    try {
      if (!selectedAsignacion) return alert("Seleccione una asignación");

      const payload = [];

      Object.keys(asistenciasMap).forEach((est) => {
        diasSemana.forEach((dia) => {
          payload.push({
            estudiante_id: est,
            asignacionId: selectedAsignacion.asignacion_id,
            profesorId,
            fecha: dia,
            estado: asistenciasMap[est][dia]
          });
        });
      });

      await api.post(`${API}/asistencias`, {
        asistencias: payload,
        asignacionId: selectedAsignacion.asignacion_id
      });

      alert("✅ Asistencias guardadas");

    } catch (err) {
      console.error(err);
      alert("Error guardando");
    }
  };

  /* =========================
     UI
  ========================= */
  return (
    <div className="ap-container">

      <div className="ap-header">
        <h2>Registro de Asistencia</h2>

        <div className="acciones-superior">

          <select
            className="select-asignacion"
            onChange={handleSelectAsignacion}
            value={selectedAsignacion?.asignacion_id || ""}
          >
            <option value="">
              Seleccione una asignación
            </option>

            {(Array.isArray(asignaciones)
              ? asignaciones
              : []
            ).map((a) => (
              <option
                key={a.asignacion_id}
                value={a.asignacion_id}
              >
                {a.grado}°{a.grupo} - {a.materia}
              </option>
            ))}
          </select>

          {selectedAsignacion && (
            <div className="acciones-fecha">

              <input
                type="date"
                value={fechaNueva}
                onChange={(e) => setFechaNueva(e.target.value)}
              />

              <button onClick={agregarDia}>
                + Agregar Día
              </button>

            </div>
          )}

        </div>
      </div>

      {error && <div className="error-box">{error}</div>}

      {loading ? (
        <div>Cargando...</div>
      ) : (
        <div className="ap-table-wrapper">

          <table className="ap-table">
            <thead>
              <tr>
                <th>Foto</th>
                <th>Estudiante</th>

                {diasSemana.map((d) => (
                  <th key={d}>
                    {d}
                    <button
                      onClick={() => eliminarDia(d)}
                      style={{ marginLeft: 4, fontSize: 10 }}
                      title="Eliminar día"
                    >
                      ✕
                    </button>
                  </th>
                ))}

              </tr>
            </thead>

            <tbody>

              {students.map((s) => (
                <tr key={s.estudiante_id}>

                  <td>
                    <img
                      src={s.foto_estudiante ||
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                      alt=""
                      className="foto-estudiante"
                    />
                  </td>

                  <td>{s.nombre_completo || `${s.nombres_estudiante} ${s.apellidos_estudiante}`}</td>

                  {diasSemana.map((d) => (
                    <td
                      key={d}
                      style={{
                        background:
                          estadoColor[
                            asistenciasMap[s.estudiante_id]?.[d]
                          ]
                      }}
                    >
                      <select
                        value={
                          asistenciasMap[s.estudiante_id]?.[d] ||
                          "presente"
                        }
                        onChange={(e) =>
                          cambiarEstado(
                            s.estudiante_id,
                            d,
                            e.target.value
                          )
                        }
                      >
                        <option value="presente">P</option>
                        <option value="ausente">A</option>
                        <option value="tarde">T</option>
                        <option value="excusa">E</option>
                      </select>
                    </td>
                  ))}

                </tr>
              ))}

            </tbody>
          </table>

        </div>
      )}

      <div className="footer-botones">

        <button onClick={guardar}>💾 Guardar</button>

      </div>

    </div>
  );
}